import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DATA_HOOKS } from './constants';

export interface BreadcrumbsDriver extends BaseUniDriver {
  getBreadcrumbsLength(): Promise<number>;
  getBreadcrumbContentAt(index: number): Promise<string>;
  clickBreadcrumbAt(index: number): Promise<void>;
  focusBreadcrumbAt(index: number): Promise<void>;
  setForceHoverAt(index: number, force: boolean): Promise<void>;
  isMobile(): Promise<boolean>;
}

export const breadcrumbsDriverFactory = (
  base: UniDriver,
): BreadcrumbsDriver => {
  const getBreadcrumbs = () =>
    base.$$(`[data-hook="${DATA_HOOKS.BREADCRUMB}"]`);
  const getBreadcrumbContentAt = async (index: number) => {
    const breadcrumbs = getBreadcrumbs();
    return breadcrumbs.get(index).text();
  };
  const getBreadcrumbButtonAt = (index: number) => {
    const breadcrumbs = getBreadcrumbs();
    const breadcrumbButton = breadcrumbs
      .get(index)
      .$(`[data-hook="${DATA_HOOKS.BREADCRUMB_BUTTON}"]`);
    return breadcrumbButton;
  };
  const clickBreadcrumbAt = async (index: number) => {
    const breadcrumbButton = getBreadcrumbButtonAt(index);
    await breadcrumbButton.click();
  };
  const focusBreadcrumbAt = async (index: number) => {
    const breadcrumbButton = getBreadcrumbButtonAt(index);
    await breadcrumbButton.getNative().then((el) => el.focus());
  };
  const setForceHoverAt = async (index: number, force: boolean) => {
    const breadcrumbButton = getBreadcrumbButtonAt(index);
    await breadcrumbButton
      .getNative()
      .then((el) =>
        el.setAttribute('data-force-hover', force ? 'true' : 'false'),
      );
  };

  return {
    ...baseUniDriverFactory(base),
    getBreadcrumbsLength: async () => getBreadcrumbs().count(),
    getBreadcrumbContentAt: async (index) => getBreadcrumbContentAt(index),
    clickBreadcrumbAt: async (index) => clickBreadcrumbAt(index),
    focusBreadcrumbAt: async (index) => focusBreadcrumbAt(index),
    setForceHoverAt: async (index, force) => setForceHoverAt(index, force),
    isMobile: async () => (await base.attr('data-mobile')) === 'true',
  };
};
